import { getRequestAction } from 'helpers/functions';

const ACTION_PREFIX = 'worklogs';

export const getWorklog = getRequestAction(`${ACTION_PREFIX}/getWorklog`);

export const getJobHistory = getRequestAction(`${ACTION_PREFIX}/getJobHistory`);
